
export const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints // http://stackoverflow.com/a/4819886/159387

// Don't try using localStorage is not supported (insights use localStorage) (i.e. incognito mode on iPad), or it will crash the app
// Still allow users to access the app and use it, but bear in mind that if the someone copies and pastes the invite link and completes the journey,
// but then reloads the page - they will "lose" their progress - they will enter an anonymous journey
// If local storage isn't supported https://stackoverflow.com/a/17604754/3263594
export const isLocalStorageNameSupported = () => {
  const testKey = 'test',
        storage = window.localStorage
  try {
    storage.setItem(testKey, '1')
    storage.removeItem(testKey)
    return true
  } catch (error) {
    return false
  }
}



/** WEBPACK FOOTER **
 ** ./src/utils/detector.js
 **/